import { useContext, useEffect, useRef, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";
import { IdcardOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import axios from "axios";

const CreateNewRFID = ({ close, closeOriginDrawer, selectedData }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const formRef = useRef(null);
  const [focused, setFocused] = useState(false);
  const [cardUIDValue, setCardUIDValue] = useState("");
  const { rerunNotif } = useContext(NotificationInfo);

  const onFocus = () => setFocused(true);

  const onBlur = (e) => {
    setFocused(false);
    if (!e.relatedTarget) {
      e.target.focus();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    axios
      .post("user/merchant/scan/rfid-user", {
        rfid: cardUIDValue,
        id: selectedData.id,
      })
      .then((response) => {
        if (focused) {
          const data = response.data;
          if (data === "success") {
            close();
            closeOriginDrawer();
            rerunNotif("success", "RFID created successfully.");
          }
        }
        setIsSubmitting(false);
        setCardUIDValue("");
        setFocused(true);
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  useEffect(() => {
    setFocused(true);
  }, []);

  return (
    <div>
      <form
        onSubmit={handleSubmit}
        ref={formRef}
        style={{
          border: "1px solid red",
          opacity: 0,
        }}
      >
        <div style={{ display: "flex", flexDirection: "row" }}>
          <input
            type="text"
            autoFocus
            name="card_uid"
            id="card_uid"
            onFocus={onFocus}
            onBlur={onBlur}
            onChange={(e) => setCardUIDValue(e.target.value)}
            value={cardUIDValue}
            autoComplete="off"
          />
          <button type="submit" disabled={isSubmitting}>
            SUBMIT
          </button>
        </div>
      </form>
      <div style={{ borderRadius: 20, marginBottom: 20 }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <IdcardOutlined style={{ fontSize: "200px" }} />
          <Typography
            style={{ fontWeight: "bold", color: "red", fontStyle: "italic" }}
          >
            Please scan the RFID
          </Typography>
          <Typography style={{ fontSize: 18, fontWeight: "bold" }}>
            Scanning...
          </Typography>
        </div>
      </div>
      <div />
    </div>
  );
};

export default CreateNewRFID;
